var React = require('react');

function Stroke3Green (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"none","stroke":"#7DB343","strokeWidth":"13","d":"M1485 290s-279 62-528 41c-101-8-256-75-344-130C425 84 243-3-14 8"}));
}

Stroke3Green.defaultProps = {"viewBox":"0 0 1440 342"};

module.exports = Stroke3Green;

Stroke3Green.default = Stroke3Green;
